"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Image_1 = __importDefault(require("stremio/components/Image"));
var useRouteFocused_1 = require("stremio/common/useRouteFocused");
var useMediaQuery_1 = __importDefault(require("stremio/common/useMediaQuery"));
var screen_sizes_less_1 = __importDefault(require("stremio/common/screen-sizes.less"));
var EPG_1 = require("stremio/common/EPG");
var Hero_1 = __importDefault(require("./Hero"));
var Schedule_1 = __importDefault(require("./Schedule"));
var Playback_1 = __importDefault(require("./Playback"));
var Actions_1 = __importDefault(require("./Actions"));
var LiveTvDetails_less_1 = __importDefault(require("./LiveTvDetails.less"));
var programKey = function (program) { var _a; return (_a = program.id) !== null && _a !== void 0 ? _a : "".concat(program.channelId, ":").concat(program.startTime.getTime()); };
var LiveTvDetails = function (_a) {
    var _b, _c, _d, _e;
    var className = _a.className, contentRef = _a.contentRef, children = _a.children, meta = _a.meta, addonName = _a.addonName, streams = _a.streams, onToggleLibrary = _a.onToggleLibrary;
    var active = (0, useRouteFocused_1.useRouteActive)();
    var isMobile = (0, useMediaQuery_1.default)("(max-width: ".concat(screen_sizes_less_1.default.xsmall, ")"));
    var now = (0, EPG_1.useLiveRefresh)('MetaDetails', 'meta_details', active);
    var _f = (0, react_1.useState)(null), selectedKey = _f[0], setSelectedKey = _f[1];
    var channel = (0, react_1.useMemo)(function () {
        var _a;
        return ({
            id: meta.id,
            type: meta.type,
            name: meta.name,
            logo: (_a = meta.logo) !== null && _a !== void 0 ? _a : meta.poster,
            deepLinks: meta.deepLinks,
        });
    }, [meta.id, meta.type, meta.name, meta.logo, meta.poster, meta.deepLinks]);
    var programs = (0, react_1.useMemo)(function () {
        return meta.videos
            .map(function (video) { return (0, EPG_1.toEpgProgram)(video, channel); })
            .filter(function (program) { return program !== null; })
            .sort(function (a, b) { return a.startTime.getTime() - b.startTime.getTime(); });
    }, [meta.videos, channel]);
    var selected = (_d = (_c = (_b = programs.find(function (program) { return programKey(program) === selectedKey; })) !== null && _b !== void 0 ? _b : programs.find(function (program) { return program.endTime.getTime() > now; })) !== null && _c !== void 0 ? _c : programs[programs.length - 1]) !== null && _d !== void 0 ? _d : null;
    var artwork = (_e = selected === null || selected === void 0 ? void 0 : selected.thumbnail) !== null && _e !== void 0 ? _e : meta.background;
    var onProgramSelect = (0, react_1.useCallback)(function (program) {
        setSelectedKey(program ? programKey(program) : null);
    }, []);
    var renderChannelBackdrop = function () {
        return channel.logo ?
            react_1.default.createElement(Image_1.default, { className: (0, classnames_1.default)(LiveTvDetails_less_1.default['backdrop-image'], LiveTvDetails_less_1.default['channel-artwork']), src: channel.logo, alt: '', renderFallback: function () { return null; } })
            :
                null;
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, LiveTvDetails_less_1.default['live-details']) },
        react_1.default.createElement("div", { className: LiveTvDetails_less_1.default['backdrop'], "aria-hidden": 'true' },
            artwork ?
                react_1.default.createElement(Image_1.default, { className: LiveTvDetails_less_1.default['backdrop-image'], src: artwork, alt: '', renderFallback: renderChannelBackdrop })
                :
                    renderChannelBackdrop(),
            react_1.default.createElement("div", { className: LiveTvDetails_less_1.default['backdrop-shade'] })),
        children,
        react_1.default.createElement("div", { ref: contentRef, className: LiveTvDetails_less_1.default['channel-page'] },
            react_1.default.createElement(Hero_1.default, { channel: channel, addonName: addonName, description: meta.description, hasSchedule: programs.length > 0, selected: selected, now: now },
                react_1.default.createElement(Actions_1.default, { inLibrary: meta.inLibrary, onToggleLibrary: onToggleLibrary }, isMobile ?
                    react_1.default.createElement(Playback_1.default, { streams: streams, mobile: true })
                    :
                        null)),
            react_1.default.createElement("div", { className: LiveTvDetails_less_1.default['guide-layout'] },
                react_1.default.createElement(Schedule_1.default, { programs: programs, now: now, selected: selected, onProgramSelect: onProgramSelect }),
                !isMobile ?
                    react_1.default.createElement(Playback_1.default, { streams: streams })
                    :
                        null))));
};
exports.default = LiveTvDetails;
